import React, {Component} from 'react';
import $ from "jquery";
import axios from "axios";
import config from "react-global-configuration";
import * as moment from "moment";
import {BeatLoader} from "react-spinners";
import {css} from '@emotion/core';
import "../assets/css/datatables/datatables.min.css";

const override = css`
    display: block;
    margin: 0 auto;
    border-color: red;
`;


class TransactionReport extends Component {
    state = {
        ReportData:[],
        loading: true
    };

    componentWillMount() {
        this._refreshReportData();
    }

    componentDidMount() {
    }

    _refreshReportData() {
        if ($.fn.DataTable.isDataTable('#reportTable')) {
            $('#reportTable').DataTable().destroy();
        }
        axios.post(config.get('API_URL') + '/diyusers/transactionReport', {}, {
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            }
        }).then(response => {
            this.setState({
                ReportData: response.data
            });

            $('#reportTable').DataTable();
            this.setState({
                loading: false
            })

        }).catch(err => {
            console.log(err);
        });
    }
    render() {
       let transactions = this.state.ReportData.map((record, index) => {

            return (
                <tr key={index + 1}>
                    <td>{record.store_code}</td>
                    <td>{record.mode}</td>
                    <td>{record.invoice_id}</td>
                    <td>{record.invoice_posted_date == null ? '' : moment(record.invoice_posted_date).format('DD/MM/YYYY HH:mm:ss')}</td>
                    <td>{record.pin_status}</td>
                    <td>{record.pin_entry_date == null ? '' : moment(record.pin_entry_date).format('DD/MM/YYYY HH:mm:ss')}</td>
                    <td>{record.payment_status}</td>
                    <td>{record.payment_update_date == null ? '' : moment(record.payment_update_date).format('DD/MM/YYYY HH:mm:ss')}</td>
                </tr>
            )
        });


        return (
            <div className="content">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12 pt-5">
                            <div className="card">
                                <div className="header">
                                    <h4 className="title">Transaction Report </h4>
                                </div>
                                <hr/>
                                <table className="table table-striped table-hover" id="reportTable">
                                    <thead>
                                    <tr>
                                        <th>Store Code</th>
                                        <th>Mode</th>
                                        <th>Invoice ID</th>
                                        <th>Invoice Posted</th>
                                        <th>PIN Status</th>
                                        <th>PIN Timestamp</th>
                                        <th>Payment Status</th>
                                        <th>Payment Update Timestamp</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {transactions}
                                    </tbody>
                                    <BeatLoader
                                        css={override}
                                        sizeUnit={"px"}
                                        size={20}
                                        color={'#123abc'}
                                        loading={this.state.loading}
                                    />
                                </table>


                                <div className="footer">
                                    <div className="stats"><i></i></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default TransactionReport;